<template>
<div>
  <banner-slider />
  <home-describe />
  <home-case />
  <comm-news />
  <contact-us />
</div>
</template>

<script>
import CommNews from "@/components/CommNews";
import ContactUs from "@/components/ContactUs";
import BannerSlider from "@/components/BannerSlider";
import HomeCase from "@/components/HomeCase";
import HomeDescribe from "@/components/HomeDescribe/index.vue";
export default {
  name: "Home",
  components: {HomeDescribe, HomeCase, BannerSlider, ContactUs, CommNews}
}
</script>

<style lang="scss" scoped>
</style>
